import React from 'react';
import icon from './../images/cup-line.svg';
import { useTranslation } from '../i18n';
import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';

const Donate = () => {
  const { t } = useTranslation();

  const handleDonate = () => {
    window.open(
      'https://www.paypal.com/donate/?hosted_button_id=M8KEAXENU6UDU',
      '_blank',
    );
    logEvent(analytics, 'account_settings_donate');
  };

  return (
    <div className="row-item" key="donate">
      <img height={24} width={24} alt="Coffee" src={icon} />
      <div
        className="link"
        onClick={handleDonate}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            handleDonate();
          }
        }}
        tabIndex={0}
      >
        {t.donate}
      </div>
    </div>
  );
};

export default Donate;
